import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Payment } from '../../firestore_model';
import { useClinicUser } from '..';
import { Utils } from '../../../common/helper';
import { useInjection } from '../../../di_container/InjectionProvider';
import { pagination } from '../../../common/constants/Constants';
export const useModificationRequest = () => {
    const { paymentClinic } = useClinicUser();
    const { t } = useTranslation();
    const { container } = useInjection();
    const [loading, setLoading] = useState(false);
    const [loadingApproval, setLoadingApproval] = useState(false);
    const columns = [
        { id: 'content', label: '業務内容', minWidth: 150 },
        { id: 'worker', label: 'ワーカー', minWidth: 80 },
        {
            id: 'modifiedAmount',
            label: '追加報酬金額',
            minWidth: 60,
            align: 'right',
            format: (val) => val.toLocaleString(),
        },
        { id: 'approveButton', label: '', minWidth: 140, align: 'right' },
    ];
    const loadModificationList = useCallback(async (lastDocument) => {
        setLoading(true);
        try {
            if (Utils.isNull(paymentClinic))
                throw new Error(t('システムエラー'));
            const firestoreRepository = container.resolve('FirestoreRepository');
            const result = await firestoreRepository.loadDocuments({
                path: paymentClinic.modificationRequests.collectionReference.path,
                isGroup: false,
                limit: pagination.limit,
                startAfter: lastDocument,
                orderBy: {
                    fieldPath: 'createdAt',
                    directionStr: 'desc',
                },
            });
            setLoading(false);
            return {
                data: result.docs.map((item) => Payment.ModificationRequest.fromSnapshot(item)),
                lastDocument: result.lastDocument,
            };
        }
        catch (e) {
            setLoading(false);
            throw e;
        }
    }, [paymentClinic]);
    const approvalCorrectReward = useCallback(async (modificationRequestId, isApprove, amount) => {
        setLoadingApproval(true);
        try {
            const imoryApiRepository = container.resolve('ImoryApiRepository');
            await imoryApiRepository.approvalCorrectReward(modificationRequestId, isApprove, amount);
            setLoadingApproval(false);
        }
        catch (e) {
            setLoadingApproval(false);
            throw e;
        }
    }, []);
    return { columns, loadModificationList, approvalCorrectReward, loading, loadingApproval };
};
